<div class="chat-container">
  <div class="header">
    <ucx-header
      [logo]="headerLogo$ | async"
      [isLiveChat]="isLiveChatHeader$ | async"
      headerTitle="{{ headerTitle$ | async }}"
      settingsTitle="{{ 'SETTINGS.TITLE' | translate }}"
      minimizeTitle="{{ 'MINIMIZE_LABEL' | translate }}"
      closeTitle="{{ 'CLOSE_LABEL' | translate }}"
      [menuItems]="menuItems | async"
      [onMenuItemChanged]="onMenuItemChanged"
      [onMinimizeChat]="onMinimizeChat"
      [onCloseChat]="onCloseChat"
      [version]="version"
      [headerBackgroundColor]="getBgColor()"
    ></ucx-header>
  </div>
  <ng-template #alertBannerRef></ng-template>
  <div #messageContainer class="message-container">
    <ng-template #messageContainerRef></ng-template>

    <ucx-message-typing-indicator
      *ngIf="isVaOrAgentTyping$ | async"
    ></ucx-message-typing-indicator>
  </div>

  <div class="footer">
    <ucx-footer-message
      #footerContainer
      inputPlaceHolder="{{ 'FOOTER_INPUT_PLACEHOLDER' | translate }}"
      [isDisabled]="isUserMessageDisabled$ | async"
      [onUserTyping]="onUserTyping"
      [onSendMessage]="onSendUserMessage"
      [onSearch]="onSuggestionsSearch"
      [onClearSuggestions]="onClearSuggestions"
      [suggestionsList]="suggestionsList$ | async"
      alertHeading="{{ 'CHARACTER_LIMIT_CAPTION' | translate }}"
      alertText="{{ 'CHARACTER_LIMIT_MESSAGE' | translate }}"
    ></ucx-footer-message>
  </div>
</div>

<ng-template #overlayComponentRef></ng-template>
